"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
const types_1 = require("~/store/types");
const utils_1 = require("../utils");
const ConnectionUtils_3d_1 = require("../utils/ConnectionUtils.3d");
const FastenersUtils_1 = require("../utils/FastenersUtils");
const Viewer_1 = __importDefault(require("../Viewer"));
const consts_1 = require("../consts");
const utils_3d_1 = require("../utils/utils.3d");
const PanelInSlotUpdateHelper_1 = __importDefault(require("./PanelInSlots/PanelInSlotUpdateHelper"));
function removePreviewFasteners(connectionObject, fasteners) {
    const previousFasteners = fasteners !== null && fasteners !== void 0 ? fasteners : connectionObject.getFasteners();
    connectionObject.removeFasteners(previousFasteners);
    previousFasteners.forEach((fastener) => Viewer_1.default.instance.collisionProcessor.notifyObjectRemoved(fastener));
}
function addPreviewFasteners(connectionObject, fasteners) {
    connectionObject.addFasteners(fasteners, true, false);
    return connectionObject
        .getFasteners()
        .flatMap((fastener) => Viewer_1.default.instance.collisionProcessor.notifyObjectAdded(fastener));
}
class FastenerPreviewHelper {
    constructor() {
        this.connectionsData = [];
        this._isEditSingleConnectionMode = false;
        this._isEditingActive = false;
        this.preloadFasteners = new Map();
    }
    get isEditSingleConnectionMode() {
        return this._isEditSingleConnectionMode;
    }
    set isEditSingleConnectionMode(value) {
        this._isEditSingleConnectionMode = value;
    }
    get isEditingActive() {
        return this._isEditingActive;
    }
    set isEditingActive(value) {
        this._isEditingActive = value;
    }
    loadFastener(fastenerItem) {
        return __awaiter(this, void 0, void 0, function* () {
            const catalog = Viewer_1.default.instance.props.catalogItems;
            const catalogItem = catalog.find((item) => item.item_number === fastenerItem.item_number);
            if (!catalogItem) {
                this.preloadFasteners.set(fastenerItem.item_number, null);
                return null;
            }
            const fastener = (yield (0, FastenersUtils_1.loadFile)(catalogItem));
            if (!fastener) {
                this.preloadFasteners.set(fastenerItem.item_number, null);
                return null;
            }
            (0, FastenersUtils_1.setFastenerMetadata)(fastener, fastenerItem);
            this.preloadFasteners.set(fastenerItem.item_number, fastener);
            return fastener;
        });
    }
    activateManualEditingMode(fastenerItem) {
        this.deactivateManualEditingMode();
        this.applyFastenerForSingleEditConnection(fastenerItem, PanelInSlotUpdateHelper_1.default.onFastenersUpdated.bind(PanelInSlotUpdateHelper_1.default), true);
    }
    deactivateManualEditingMode() {
        const connectionData = this.connectionsData[0];
        if (!connectionData || !connectionData.previewData) {
            return;
        }
        removePreviewFasteners(connectionData.connectionObject, connectionData.connectionObject
            .getFasteners()
            .filter((fastener) => fastener.fastenerState === consts_1.consts.EMPTY_MODEL));
        connectionData.previewData.fasteners = connectionData.previewData.fasteners.filter((fastener) => fastener.fastenerState !== consts_1.consts.EMPTY_MODEL);
        connectionData.connectionObject.setFastenersVisualState('selected');
    }
    setDataForEditSingleConnection(uuid, fastenersToPreload) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.setProcessConnections([uuid], uuid);
            // This seems to be useless
            // this.preloadFasteners.clear();
            this.isEditSingleConnectionMode = true;
            yield Promise.all(fastenersToPreload.map((fastenerItem) => this.loadFastener(fastenerItem)));
            (_a = this.onConnectionValidationUpdated) === null || _a === void 0 ? void 0 : _a.call(null, this.connectionsData[0]);
        });
    }
    setProcessConnections(uuids, selectedConnectionUUID) {
        var _a, _b;
        this.cancelApplication();
        this.isEditSingleConnectionMode = false;
        const selectedConnection = Viewer_1.default.instance.getObjectById(selectedConnectionUUID);
        if (!selectedConnection) {
            return;
        }
        const connectedExtrusionSize = types_1.FASTENER_TYPES_OF_DOUBLE_ANCHOR_GROUP.includes((_b = (_a = selectedConnection.getFasteners()[0]) === null || _a === void 0 ? void 0 : _a.fastenerType) !== null && _b !== void 0 ? _b : '')
            ? selectedConnection.getConnection().extrusionSideHeightConnectedByEnd
            : undefined;
        uuids.forEach((uuid) => {
            var _a;
            const connectionObject = Viewer_1.default.instance.getObjectById(uuid);
            if (connectedExtrusionSize &&
                utils_1.Utils.areNotEqual(connectedExtrusionSize, (_a = connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.getConnection().extrusionSideHeightConnectedByEnd) !== null && _a !== void 0 ? _a : 0)) {
                return;
            }
            if (connectionObject) {
                const mainObject = connectionObject.getMainObject();
                const connectedObject = connectionObject.getConnectedObject();
                connectionObject.selectFasteners();
                this.connectionsData.push({
                    connectionObject,
                    mainObject,
                    connectedObject,
                    previewData: null,
                    initialFasteners: connectionObject.getFasteners(),
                });
            }
        });
        if (this.connectionsData.length) {
            this.isEditingActive = true;
        }
        if (this.connectionsData.length > 1) {
            const box = utils_1.Utils.getAABBox(this.connectionsData[0].connectionObject);
            this.connectionsData.forEach((data) => {
                box.expandByObject(data.connectedObject);
                box.expandByObject(data.mainObject);
                box.expandByObject(data.connectionObject);
            });
            Viewer_1.default.instance.zoomToFit(box);
        }
    }
    removeFastenerInSingleConnectionMode(fastenerItem) {
        var _a;
        this.deactivateManualEditingMode();
        const connectionData = this.connectionsData[0];
        if (!connectionData) {
            return;
        }
        const fastenersToRemove = connectionData.connectionObject
            .getFasteners()
            .filter((fastener) => fastener.partDetails.itemNumber === fastenerItem.item_number);
        removePreviewFasteners(connectionData.connectionObject, fastenersToRemove);
        if (fastenersToRemove.length) {
            (_a = this.onConnectionValidationUpdated) === null || _a === void 0 ? void 0 : _a.call(null, connectionData);
        }
    }
    applyFastener(fastenerItem, onFastenersPreviewAddedCallback, manuallyEditingModeOn = false) {
        var _a;
        this.deactivateManualEditingMode();
        if (this.isEditSingleConnectionMode) {
            this.applyFastenerForSingleEditConnection(fastenerItem, onFastenersPreviewAddedCallback, manuallyEditingModeOn);
            (_a = this.onConnectionValidationUpdated) === null || _a === void 0 ? void 0 : _a.call(null, this.connectionsData[0]);
        }
        else {
            this.applyFastenerForMultipleConnections(fastenerItem, onFastenersPreviewAddedCallback);
        }
    }
    applyFastenerForSingleEditConnection(fastenerItem, onFastenersPreviewAddedCallback, manuallyEditingModeOn = false) {
        const connectionData = this.connectionsData[0];
        if (!connectionData) {
            return;
        }
        const fastenersToAdd = this.getAppliableFastenersObjectsForCurrentConnection(fastenerItem, manuallyEditingModeOn);
        if (!manuallyEditingModeOn) {
            const data = connectionData.connectionObject.getFasteners().filter((fastener) => {
                return fastener.partDetails.itemNumber !== fastenerItem.item_number;
            });
            removePreviewFasteners(connectionData.connectionObject, data);
        }
        addPreviewFasteners(connectionData.connectionObject, fastenersToAdd);
        if (connectionData.previewData) {
            connectionData.previewData.fasteners.push(...fastenersToAdd);
        }
        else {
            connectionData.previewData = { fasteners: fastenersToAdd };
        }
        onFastenersPreviewAddedCallback === null || onFastenersPreviewAddedCallback === void 0 ? void 0 : onFastenersPreviewAddedCallback.call(null, [connectionData.connectionObject]);
        const collidedObjectsUUID = new Set();
        connectionData.connectionObject.getFasteners().forEach((fastener) => {
            const collidedUUIDs = Viewer_1.default.instance.collisionProcessor.updateCollisions(fastener, null, false);
            if (collidedUUIDs.length) {
                collidedUUIDs.forEach((uuid) => collidedObjectsUUID.add(uuid));
                collidedObjectsUUID.add(fastener.uuid);
            }
        });
        (0, utils_3d_1.dispatchNotificationEventAboutCollisionBetweenObjects)(collidedObjectsUUID);
        if (manuallyEditingModeOn) {
            connectionData.connectionObject.getFasteners().forEach((fastener) => {
                if (fastener.partDetails.itemNumber === fastenerItem.item_number) {
                    fastener.setVisualState && fastener.setVisualState('filled model');
                }
                else {
                    fastener.setVisualState && fastener.setVisualState('selected');
                }
            });
            // TODO reverify if it's required
            // fastenersToAdd.forEach((fastener) => fastener.setVisualState(consts.EMPTY_MODEL));
        }
        else {
            connectionData.connectionObject.setFastenersVisualState('selected');
        }
    }
    getAppliableFastenersObjectsForCurrentConnection(fastenerItem, manuallyEditingModeOn) {
        var _a, _b;
        if (!this.preloadFasteners.has(fastenerItem.item_number)) {
            return [];
        }
        const fastenerPrototype = this.preloadFasteners.get(fastenerItem.item_number);
        const connectionData = this.connectionsData[0];
        if (!fastenerPrototype ||
            !connectionData ||
            !(0, FastenersUtils_1.validateScrewFastenersToExtrusionMatch)(connectionData.connectionObject.uuid, fastenerItem)) {
            return [];
        }
        const { connectionObject } = connectionData;
        const { mainItem, connectedItem } = connectionObject.getConnectionItems();
        const { connectionType } = connectionObject.getConnection();
        const previewFasteners = (_b = (_a = (0, ConnectionUtils_3d_1.tryToVisualizeFasteners)(connectionData.mainObject, connectionData.connectedObject, mainItem, connectedItem, connectionType, fastenerPrototype)) === null || _a === void 0 ? void 0 : _a.fasteners) !== null && _b !== void 0 ? _b : [];
        // TODO Review fix on visualization refactoring
        if (connectionType === types_1.CONNECTION_TYPE.END_TO_END) {
            fastenerPrototype.removeFromParent();
        }
        if (!manuallyEditingModeOn) {
            return previewFasteners;
        }
        const connectionVisibleFasteners = connectionObject
            .getFasteners()
            .filter((fastener) => fastener.visible && fastener.fastenerState !== consts_1.consts.EMPTY_MODEL);
        return previewFasteners.filter((previewFastener) => connectionVisibleFasteners.every((connectionFastener) => !previewFastener.testIntersection(connectionFastener)));
    }
    applyFastenerForMultipleConnections(fastenerItem, onFastenersPreviewAddedCallback) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const catalogItem = Viewer_1.default.instance.props.catalogItems.find((item) => item.item_number === fastenerItem.item_number);
            if (!catalogItem) {
                return;
            }
            const fastenerPrototype = (yield (0, FastenersUtils_1.loadFile)(catalogItem));
            if (!fastenerPrototype) {
                return;
            }
            (0, FastenersUtils_1.setFastenerMetadata)(fastenerPrototype, fastenerItem);
            this.connectionsData.forEach((connectionData) => {
                const { connectionObject } = connectionData;
                if (!(0, FastenersUtils_1.validateScrewFastenersToExtrusionMatch)(connectionObject.uuid, fastenerItem)) {
                    removePreviewFasteners(connectionObject);
                    addPreviewFasteners(connectionObject, connectionData.initialFasteners);
                    connectionObject.showConnection();
                    connectionData.previewData = null;
                    return;
                }
                removePreviewFasteners(connectionObject);
                const { mainItem, connectedItem } = connectionObject.getConnectionItems();
                if (!mainItem || !connectedItem) {
                    return;
                }
                const previewData = (0, ConnectionUtils_3d_1.tryToVisualizeFasteners)(connectionData.mainObject, connectionData.connectedObject, mainItem, connectedItem, connectionObject.getConnection().connectionType, fastenerPrototype);
                if (previewData) {
                    connectionObject.makeSphereInvisible();
                    addPreviewFasteners(connectionObject, previewData.fasteners);
                    connectionData.previewData = previewData;
                    connectionObject.showFasteners();
                }
                else {
                    addPreviewFasteners(connectionObject, connectionData.initialFasteners);
                    connectionObject.showConnection();
                    connectionData.previewData = null;
                }
                connectionObject.setFastenersVisualState('selected');
            });
            onFastenersPreviewAddedCallback === null || onFastenersPreviewAddedCallback === void 0 ? void 0 : onFastenersPreviewAddedCallback(this.connectionsData.filter((data) => data.previewData).map((data) => data.connectionObject));
            const collidedObjectsUUID = new Set();
            this.connectionsData.forEach((connectionData) => {
                connectionData.connectionObject.getFasteners().forEach((fastener) => {
                    const previousFastenerState = fastener.fastenerState;
                    const uuids = Viewer_1.default.instance.collisionProcessor.updateCollisions(fastener, null, false);
                    if (!uuids.length) {
                        fastener.setVisualState && fastener.setVisualState(previousFastenerState);
                    }
                    // Collect UUIDs of preview fasteners only.
                    if (connectionData.previewData && uuids.length) {
                        uuids.forEach((uuid) => collidedObjectsUUID.add(uuid));
                        collidedObjectsUUID.add(fastener.uuid);
                    }
                });
            });
            (0, utils_3d_1.dispatchNotificationEventAboutCollisionBetweenObjects)(collidedObjectsUUID);
            (_a = this.onFastenersPreviewApplied) === null || _a === void 0 ? void 0 : _a.call(null, this.connectionsData);
        });
    }
    flipFastener(fastenerItemNumber, onFastenerPreviewAddedCallback) {
        var _a, _b, _c, _d;
        this.deactivateManualEditingMode();
        if (this.connectionsData.length !== 1) {
            return;
        }
        const connectionData = this.connectionsData[0];
        const fastenersToFlip = ((_b = (_a = connectionData.previewData) === null || _a === void 0 ? void 0 : _a.fasteners) !== null && _b !== void 0 ? _b : connectionData.initialFasteners).filter((fastener) => fastener.partDetails.itemNumber === fastenerItemNumber);
        if (!utils_1.Utils.isExtrusion(connectionData.mainObject) ||
            !utils_1.Utils.isExtrusion(connectionData.connectedObject) ||
            ![
                ...types_1.FASTENER_TYPES_OF_GROUP_A,
                ...types_1.FASTENER_TYPES_OF_END_TO_END_GROUP,
                types_1.FASTENER_TYPES.ZERO_DEGREE_CENTRAL_CONNECTOR,
            ].includes((_d = (_c = fastenersToFlip[0]) === null || _c === void 0 ? void 0 : _c.fastenerType) !== null && _d !== void 0 ? _d : '')) {
            return;
        }
        const flipResult = utils_1.ConnectionUtils.tryToFlipFasteners(connectionData.connectedObject, connectionData.mainObject, fastenersToFlip);
        if (!flipResult || flipResult.fasteners.length !== fastenersToFlip.length) {
            return;
        }
        const { connectionObject } = connectionData;
        removePreviewFasteners(connectionObject, fastenersToFlip);
        addPreviewFasteners(connectionObject, flipResult.fasteners);
        onFastenerPreviewAddedCallback === null || onFastenerPreviewAddedCallback === void 0 ? void 0 : onFastenerPreviewAddedCallback([connectionObject]);
        const collidedObjectsUUID = new Set();
        connectionObject.getFasteners().forEach((fastener) => {
            const collidedUUIDs = Viewer_1.default.instance.collisionProcessor.updateCollisions(fastener, null, false);
            if (collidedUUIDs.length) {
                collidedUUIDs.forEach((uuid) => collidedObjectsUUID.add(uuid));
                collidedObjectsUUID.add(fastener.uuid);
            }
        });
        // TODO change this when flip for part of connection fastener will be implemented
        connectionData.previewData = flipResult;
        connectionObject.showFasteners();
        connectionObject.showSelectionBox(consts_1.consts.ACTIVE_SELECTION_BOX_COLOR_VECTOR);
        (0, utils_3d_1.dispatchNotificationEventAboutCollisionBetweenObjects)(collidedObjectsUUID);
    }
    finalizeApplication() {
        var _a;
        this.deactivateManualEditingMode();
        if (this.isEditSingleConnectionMode && ((_a = this.connectionsData[0]) === null || _a === void 0 ? void 0 : _a.previewData)) {
            this.connectionsData[0].previewData = utils_1.ConnectionUtils.getConnectionMetadataByFastenersPosition(this.connectionsData[0].connectionObject.getFasteners(), this.connectionsData[0].connectedObject, this.connectionsData[0].mainObject);
        }
        this.isEditingActive = false;
        this.isEditSingleConnectionMode = false;
        const result = [];
        this.connectionsData.forEach((data) => {
            if (!data.previewData) {
                return;
            }
            data.connectionObject.removeSphere();
            const fastener = data.previewData.fasteners[0];
            const connection = data.connectionObject.getConnection();
            (0, FastenersUtils_1.updateConnectionDataAfterFastenersVisualization)(connection, fastener.partDetails.itemNumber, data.previewData, data.connectionObject, fastener.distanceToTheEdge);
            data.connectionObject.unselectFasteners();
            result.push(data);
        });
        this.connectionsData = [];
        return result;
    }
    cancelApplication() {
        this.deactivateManualEditingMode();
        this.isEditingActive = false;
        this.isEditSingleConnectionMode = false;
        this.connectionsData.forEach((connectionData) => {
            const { connectionObject } = connectionData;
            connectionObject.removeFasteners();
            connectionObject.addFasteners(connectionData.initialFasteners);
            connectionObject.setFastenersVisualState('selected');
            connectionObject.unselectFasteners();
            connectionObject.showSelectionBox();
            connectionObject.showConnection();
        });
        this.connectionsData = [];
    }
}
const fastenerPreviewHelper = new FastenerPreviewHelper();
exports.default = fastenerPreviewHelper;
